<template>
  <div class="profile-pegawai-container p-4 md:p-6">
    <!-- Header -->
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">Profile Pegawai</h1>
      <p class="text-gray-600">Akses dan kelola informasi profil pegawai</p>
    </div>

    <!-- Main Redirect Card -->
    <div class="bg-white rounded-lg shadow-lg overflow-hidden">
      <!-- Gradient Header -->
      <div class="bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 h-32"></div>
      
      <!-- Content -->
      <div class="redirect-content px-8 pb-8 -mt-16 relative">
        <!-- Icon -->
        <div class="redirect-icon mb-6">
          <div class="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg mx-auto border-4 border-white">
            <i class="el-icon-user-solid text-5xl text-blue-600"></i>
          </div>
        </div>

        <!-- Text Content -->
        <div class="text-center mb-6">
          <h3 class="text-2xl font-bold text-gray-800 mb-2">Profile Pegawai</h3>
          <p class="text-gray-600 max-w-md mx-auto">
            Kelola data dan informasi profil pegawai, termasuk data pribadi, kontak, dan informasi kepegawaian
          </p>
        </div>

        <!-- Features List -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 max-w-3xl mx-auto">
          <div class="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
            <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i class="el-icon-document text-blue-600"></i>
            </div>
            <div>
              <p class="text-sm font-semibold text-gray-800">Data Pribadi</p>
              <p class="text-xs text-gray-600">Informasi lengkap pegawai</p>
            </div>
          </div>

          <div class="flex items-center gap-3 p-3 bg-purple-50 rounded-lg">
            <div class="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i class="el-icon-phone text-purple-600"></i>
            </div>
            <div>
              <p class="text-sm font-semibold text-gray-800">Kontak</p>
              <p class="text-xs text-gray-600">Email dan telepon</p>
            </div>
          </div>

          <div class="flex items-center gap-3 p-3 bg-pink-50 rounded-lg">
            <div class="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i class="el-icon-office-building text-pink-600"></i>
            </div>
            <div>
              <p class="text-sm font-semibold text-gray-800">Kepegawaian</p>
              <p class="text-xs text-gray-600">Jabatan dan divisi</p>
            </div>
          </div>
        </div>

        <!-- Action Button -->
        <div class="text-center">
          <el-button 
            type="primary" 
            @click="goToProfilePegawai" 
            size="large"
            class="px-8 py-3"
          >
            <i class="el-icon-right mr-2"></i>
            Buka Profile Pegawai
          </el-button>
        </div>

        <!-- Info Footer -->
        <div class="mt-6 pt-6 border-t border-gray-200">
          <div class="flex items-center justify-center gap-2 text-sm text-gray-500">
            <i class="el-icon-info"></i>
            <span>Anda akan diarahkan ke halaman detail profil pegawai</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Info Cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      <!-- Info Card 1 -->
      <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-6 border border-blue-200">
        <div class="flex items-start gap-4">
          <div class="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <i class="el-icon-edit text-white text-xl"></i>
          </div>
          <div>
            <h4 class="font-semibold text-gray-800 mb-2">Edit & Update</h4>
            <p class="text-sm text-gray-600">
              Perbarui informasi profil pegawai kapan saja dengan mudah dan cepat
            </p>
          </div>
        </div>
      </div>

      <!-- Info Card 2 -->
      <div class="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-6 border border-purple-200">
        <div class="flex items-start gap-4">
          <div class="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <i class="el-icon-view text-white text-xl"></i>
          </div>
          <div>
            <h4 class="font-semibold text-gray-800 mb-2">Lihat Detail</h4>
            <p class="text-sm text-gray-600">
              Akses informasi lengkap dan riwayat profil pegawai dengan detail
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProfilePegawaiView",
  methods: {
    goToProfilePegawai() {
      this.$router.push('/profile-pegawai')
    }
  }
};
</script>

<style scoped>
.profile-pegawai-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
}

.redirect-icon {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Hover Effects */
.bg-blue-50:hover {
  background-color: #dbeafe;
  transition: all 0.3s ease;
}

.bg-purple-50:hover {
  background-color: #e9d5ff;
  transition: all 0.3s ease;
}

.bg-pink-50:hover {
  background-color: #fce7f3;
  transition: all 0.3s ease;
}

/* Button Hover */
.el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
}

/* Card Hover */
.bg-white {
  transition: all 0.3s ease;
}

.bg-white:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* Gradient Animation */
.bg-gradient-to-r {
  background-size: 200% auto;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0%, 100% {
    background-position: 0% center;
  }
  50% {
    background-position: 100% center;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .redirect-content {
    padding: 2rem 1rem !important;
  }
  
  .grid-cols-3 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
